import {ComponentType, lazy, memo} from 'react';

// hack to allow using generic components with memo
// DO NOT TRY TO PASS GENERIC PARAMETERS TO THIS FUNCTION!
export const typedMemo: <Props extends object, Return extends React.ReactNode>(
    Component: (props: Props) => Return,
    compare?: (prevProps: Props, newProps: Props) => boolean,
) => (props: Props) => Return = memo;

export const typedLazy = lazy as LazyTyped;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LazyTyped = <T extends ComponentType<any>>(factory: () => Promise<{default: T}>) => T;

export {unstable_batchedUpdates as batchUpdates} from 'react-dom';
